!function (e, t) {
  "object" == typeof exports && "undefined" != typeof module ? t(exports) : "function" == typeof define && define.amd ? define(["exports"], t) : t((e = e || self)["@tinacms/core"] = {});
}(this, function (e) {
  "use strict";

  var t = (n.prototype.getType = function (e) {
    return this.plugins[e] = this.plugins[e] || new i(e, this.events);
  }, n.prototype.findOrCreateMap = function (e) {
    return this.getType(e);
  }, n.prototype.add = function (e) {
    this.findOrCreateMap(e.__type).add(e);
  }, n.prototype.remove = function (e) {
    this.findOrCreateMap(e.__type).remove(e);
  }, n.prototype.all = function (e) {
    return this.findOrCreateMap(e).all();
  }, n);

  function n(e) {
    this.events = e, this.plugins = {};
  }

  var i = (s.prototype.add = function (e) {
    var t = e;
    t.__type || (t.__type = this.__type), this.__plugins[t.name] = t, this.events.dispatch({
      type: "plugin:add:" + this.__type
    });
  }, s.prototype.all = function () {
    var t = this;
    return Object.keys(this.__plugins).map(function (e) {
      return t.__plugins[e];
    });
  }, s.prototype.find = function (e) {
    return this.__plugins[e];
  }, s.prototype.remove = function (e) {
    var t = "string" == typeof e ? e : e.name,
        n = this.__plugins[t];
    return delete this.__plugins[t], this.events.dispatch({
      type: "plugin:remove:" + this.__type
    }), n;
  }, s.prototype.subscribe = function (e) {
    return this.events.subscribe("plugin:*:" + this.__type, e);
  }, s);

  function s(e, t) {
    this.__type = e, this.events = t, this.__plugins = {};
  }

  var r = function r() {
    var i = this;
    this.listeners = new Set(), this.subscribe = function (e, t) {
      var n = new o(e, t);
      return i.listeners.add(n), function () {
        i.listeners.delete(n);
      };
    }, this.dispatch = function (t) {
      Array.from(i.listeners.values()).forEach(function (e) {
        return e.handleEvent(t);
      });
    };
  },
      o = (u.prototype.handleEvent = function (e) {
    return !!this.watchesEvent(e) && (this.callback(e), !0);
  }, u.prototype.watchesEvent = function (e) {
    if ("*" === this.eventPattern) return !0;

    for (var t = e.type.split(":"), n = this.eventPattern.split(":"), i = 0, s = !1; !s && i < n.length;) {
      var r = "*" === n[i],
          o = n[i] === t[i];
      s = !(r || o), i++;
    }

    return !s;
  }, u);

  function u(e, t) {
    this.eventPattern = e, this.callback = t;
  }

  var p = (a.prototype.registerApi = function (e, t) {
    this.api[e] = t;
  }, Object.defineProperty(a.prototype, "enabled", {
    get: function get() {
      return this._enabled;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(a.prototype, "disabled", {
    get: function get() {
      return !this._enabled;
    },
    enumerable: !0,
    configurable: !0
  }), a.ENABLED = {
    type: "cms:enable"
  }, a.DISABLED = {
    type: "cms:disable"
  }, a);

  function a(e) {
    var i = this;
    void 0 === e && (e = {}), this._enabled = !0, this.api = {}, this.events = new r(), this.enable = function () {
      i._enabled = !0, i.events.dispatch(a.ENABLED);
    }, this.disable = function () {
      i._enabled = !1, i.events.dispatch(a.DISABLED);
    }, this.toggle = function () {
      i.enabled ? i.disable() : i.enable();
    }, this.plugins = new t(this.events), e.plugins && e.plugins.forEach(function (e) {
      return i.plugins.add(e);
    }), e.apis && Object.entries(e.apis).forEach(function (e) {
      var t = e[0],
          n = e[1];
      return i.registerApi(t, n);
    }), e.enabled || void 0 === e.enabled ? this.enable() : this.disable();
  }

  var c = (h.prototype.subscribe = function (e) {
    var t = this;
    return this.__subscribers.push(e), function () {
      return t.unsubscribe(e);
    };
  }, h.prototype.unsubscribe = function (e) {
    var t = this.__subscribers.indexOf(e);

    this.__subscribers.splice(t, 1);
  }, h.prototype.notifiySubscribers = function () {
    this.__subscribers.forEach(function (e) {
      return e();
    });
  }, h);

  function h() {
    this.__subscribers = [];
  }

  e.CMS = p, e.EventBus = r, e.Listener = o, e.PluginType = i, e.PluginTypeManager = t, e.Subscribable = c, Object.defineProperty(e, "__esModule", {
    value: !0
  });
});